import SeoHead from '@presentation/seo/SeoHead'

type LegalSection = {
  title: string
  paragraphs: string[]
}

const MEDICAL_DISCLAIMER_SECTIONS: LegalSection[] = [
  {
    title: 'Purpose and Scope',
    paragraphs: [
      'This Medical Disclaimer is provided by Parkinson\'s Insights, a collaborative platform between PD Buddy (Good Vibes Technologies Ltd) and No Silver Bullet 4PD. It applies to all content, including articles, webinars, interviews, newsletters, and information within the PD Buddy app.',
    ],
  },
  {
    title: 'Not Medical Advice',
    paragraphs: [
      'The information provided on Parkinson\'s Insights is for educational and informational purposes only. It is intended to share the personal experiences of Michel and Beatrice, alongside insights from various experts. It is not a substitute for professional medical advice, diagnosis, or treatment.',
    ],
  },
  {
    title: 'Professional Consultation Required',
    paragraphs: [
      'Always seek the advice of your neurologist, GP, or other qualified health provider with any questions you may have regarding Parkinson\'s as a condition. Never disregard professional medical advice or delay seeking it because of something you have read on this website.',
    ],
  },
  {
    title: 'No Doctor-Patient Relationship',
    paragraphs: [
      'Your use of this website, the PD Buddy app, or your participation in No Silver Bullet 4PD webinars does not create a doctor-patient relationship between you and the founders, contributors, or any featured experts.',
    ],
  },
  {
    title: 'Personal Responsibility',
    paragraphs: [
      'Every person with Parkinson\'s is unique. Strategies involving exercise, nutrition, supplements, or lifestyle changes described here should be discussed with your medical team before implementation. You agree that your use of any information provided is at your own risk. Parkinson\'s Insights and its affiliates are not responsible for any adverse effects or consequences resulting from the use of any suggestions or procedures described on the platform.',
    ],
  },
]

export default function MedicalDisclaimerPage() {
  return (
    <main className="bg-background py-8 sm:py-12">
      <SeoHead
        title="Medical Disclaimer | Parkinson's Insights"
        description="Read the Parkinson's Insights medical disclaimer and important guidance about using educational content responsibly."
        canonicalPath="/legal/medical-disclaimer"
      />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-border-light bg-surface p-6 shadow-sm sm:p-8">
          <header className="border-b border-border-light pb-5 sm:pb-6">
            <h1 className="text-2xl font-bold tracking-tight text-primary sm:text-3xl">
              Medical Disclaimer
            </h1>
            <p className="mt-2 text-sm font-medium text-text-secondary">
              Last Updated: March 2026
            </p>
          </header>

          {MEDICAL_DISCLAIMER_SECTIONS.map((section) => (
            <section
              key={section.title}
              className="border-b border-border-light py-5 last:border-b-0 last:pb-0 sm:py-6"
            >
              <h2 className="text-xl font-bold tracking-tight text-primary sm:text-2xl">
                {section.title}
              </h2>
              <div className="mt-4 space-y-4">
                {section.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-base leading-relaxed text-text-primary"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  )
}
